import {
  /* Box, */ IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core'
import { /* forwardRef, */ useState } from 'react'
import { MdVisibility, MdVisibilityOff } from 'react-icons/md'
// import zxcvbn from 'zxcvbn';

const PasswordField = (props) => {
  // const { value, disabled } = props;
  const [mostrarSenha, setMostrarSenha] = useState(false)
  // const [senhaFocus, setSenhaFocus] = useState(false);

  const tooglePassword = () => setMostrarSenha((ms) => !ms)

  return (
    // <div className={`${value.length > 0 && !disabled && 'strength-textField'}`} {...props}>
    <TextField
      // variant='outlined'
      // fullWidth
      // margin='dense'
      // InputLabelProps={{ style: { color: (value.length > 0 && senhaFocus) ? retornaCor(zxcvbn(value).score) : '' } }}
      type={mostrarSenha ? 'text' : 'password'}
      // onFocus={() => setSenhaFocus(true)}
      // onBlur={() => setSenhaFocus(false)}
      // inputProps={{ id: 'senha', name: `${zxcvbn(value).score}` }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              edge="end"
              onClick={tooglePassword}
              // onMouseDown={e => e.preventDefault()}
            >
              {mostrarSenha ? <MdVisibility /> : <MdVisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
    //   {/* {!disabled && value && (
    //     <Box display='flex' className={value.length === 0 ? 'invisible' : ''}>
    //       <Box flexGrow='1' className={'strength-meter mt-2'}>
    //         <Box className="strength-meter-fill" data-strength={zxcvbn(value).score}></Box>
    //       </Box>
    //       <Box marginLeft='5px'>{retornaForca(zxcvbn(value).score)}</Box>
    //     </Box>
    //   )}
    // </div> */}
  )
}

export default PasswordField

// export const retornaForca = (forca) => {
//   switch (forca) {
//     case 0:
//       return 'Muito Fraca';
//     case 1:
//       return 'Fraca';
//     case 2:
//       return 'Moderada';
//     case 3:
//       return 'Forte';
//     case 4:
//       return 'Muito Forte';
//     default:
//       break;
//   }
// };

// export const retornaCor = (forca) => {
//   switch (forca) {
//     case 0:
//       return 'darkred';
//     case 1:
//       return 'orangered';
//     case 2:
//       return 'orange';
//     case 3:
//       return 'yellowgreen';
//     case 4:
//       return 'green';
//     default:
//       break;
//   }
// };
